export default __webpack_public_path__ + "static/media/kycDetails@2x.fb98abd8.png";